export default "/images/minus.svg?595a628f1d89b51f5ee67012ae076ac8";